import { ISafetyCaseHazardMitigationValues } from './safety-case-hazard-mitigation-form-types'
import { ISafetyCaseHazardMitigation, ISafetyCaseHazardMitigationUpsert } from '../../../../interfaces'

export const safetyCaseHazardMitigationToSafetyCaseHazardMitigationValues = (
  mitigation: ISafetyCaseHazardMitigation | undefined,
): ISafetyCaseHazardMitigationValues | undefined => {
  if (!mitigation) {
    return undefined
  }

  return {
    description: mitigation?.description,
    mitigationTypeId: mitigation?.mitigationType,
    statusId: mitigation?.statusId,
  }
}

export const safetyCaseHazardMitigationValuesToSafetyCaseHazardMitigationAddUpsert = (
  safetyCaseHazardMitigationValues: ISafetyCaseHazardMitigationValues,
  payload: { hazardId: number },
): ISafetyCaseHazardMitigationUpsert | undefined => {
  if (!safetyCaseHazardMitigationValues || !payload?.hazardId) {
    return undefined
  }

  return {
    hazardId: payload.hazardId,
    description: safetyCaseHazardMitigationValues?.description,
    mitigationType: safetyCaseHazardMitigationValues?.mitigationTypeId,
    statusId: safetyCaseHazardMitigationValues?.statusId,
    workOrderIds: [],
  }
}

export const safetyCaseHazardMitigationValuesToSafetyCaseHazardMitigationUpdateUpsert = (
  safetyCaseHazardMitigationValues: ISafetyCaseHazardMitigationValues,
  mitigation?: ISafetyCaseHazardMitigation,
): ISafetyCaseHazardMitigationUpsert | undefined => {
  if (!safetyCaseHazardMitigationValues || !mitigation) {
    return undefined
  }

  return {
    id: mitigation.id,
    hazardId: mitigation.hazardId,
    description: safetyCaseHazardMitigationValues?.description,
    mitigationType: safetyCaseHazardMitigationValues?.mitigationTypeId,
    statusId: safetyCaseHazardMitigationValues?.statusId,
    workOrderIds: (mitigation.workOrders || []).map(workOrder => workOrder.id),
  }
}
